import { useEffect, useRef, useState } from 'react';
import { Table, Input, Button, Select, Form, InputNumber, Radio, Space, Tag, Row, Col, DatePicker } from 'antd';
import { EditOutlined, DeleteOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';
import ActionColumn from '../inventoryServices/components/ActionColumn';
import dayjs from 'dayjs';


const EditableCell = ({ editing, dataIndex, title, form, inputType, options, record, index, children, ...restProps }) => {
  const onChange = (v, opt) => {
    form.setFieldValue(`${dataIndex}${record.key}`, opt.label );
    
    if (dataIndex === 'product_id') {
      form.setFieldValue('on_hand_quantity', opt.qty);
      let ven = opt?.vendors?.map(vendor => ({value: vendor.id, label: vendor.name, qty: vendor.quantity}));
      form.setFieldValue('vendors', ven);

    }
  }; 

  useEffect(() => {
    if (record) {
      const value = form.getFieldValue(`${dataIndex}${record.key}`);
      // console.log(value)
      if (value === undefined && options) {
        // let id = record
        let account = options.find(opt => opt.value === record[dataIndex]);
        
        if (account !== undefined) {
          form.setFieldValue(`${dataIndex}${record.key}`, account.label);
        }
      }
      if (inputType === 'date') {
        record[dataIndex] = dayjs(record[dataIndex], 'YYYY-MM-DD');
      }
    }

  },[record]) 


  
  const filter = (input, option) => (
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  )
  const inputNode = inputType === 'select' ? 
    <Select 
      // onDeselect={(v)=> (dataIndex === 'taxes' || dataIndex === 'analytics') && onDeselected(v, form, options, dataIndex)} 
      // mode={(dataIndex === 'taxes' || dataIndex==='analytics') && 'tags'} 
      options={(dataIndex === 'vendor_id' && form.getFieldValue('vendors')?.length > 0) ? form.getFieldValue('vendors') : options} 
      labelRender={_ => <>{dataIndex === 'product_id' && record.product !== undefined ? record.product: _.label}</>}
      onChange={onChange}
      showSearch
      filterOption={filter}
      // onChange={(value, option)=>onChange(option, form, dataIndex)} 
    /> :
    inputType === 'date' ? 
    <DatePicker /> :
    inputType === 'number' ?
    <InputNumber />
    : <Input />; 


  return (
    <td {...restProps} >
      {editing ? (
        <Form.Item name={dataIndex} className='m-0' >
          {inputNode}
        </Form.Item>
      ) : (
        <>{
            // inputType === 'select' && dataIndex === 'taxes' ?
            // form.getFieldValue('tax'+record.key) && 
            // form.getFieldValue('tax'+record.key).map(tax => <Tag key={tax}>{tax}</Tag>) : 
            // inputType === 'select' && dataIndex === 'analytics' ?
            // form.getFieldValue('analytic'+record.key) && 
            // form.getFieldValue('analytic'+record.key).map(analytic => <Tag key={analytic}>{analytic}</Tag>) : 
            // inputType === 'select' && dataIndex === 'account_id' ? 
            // form.getFieldValue(record.account_id) : 
            (inputType === 'select' && dataIndex === 'product_id' && record.product !== undefined) ? record.product :
            (inputType === 'select' ) ? form.getFieldValue(`${dataIndex}${record.key}`) :
            inputType === 'date' ? new Date(record[dataIndex]).toLocaleDateString() :
            children
            }</>
      )}
    </td>
  );
};



const RowEditableTable = ({dataSource, apiSave, handlenavigate, setDataSource, columns, editingKey, rowSelection, setEditingKey, options, onClick, triggers, routes }) => {
  const { products, users, locations } = options;
  const [form] = Form.useForm();
  const isEditing = (record) => record.key === editingKey;
 
  const edit = async (record) => {
    form.setFieldsValue({ ...record })
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey('')
  }

  const save = async (record) => {
    try {
      const key = record.key;
      let row = await form.validateFields();
      // console.log(row)
      const newData = [...dataSource]
      const index = newData.findIndex((item) => key === item.key)
      if (index > -1) {
        let item = newData[index];

        if (item.counted_quantity >= 0) row['quantity_difference'] = row.counted_quantity - item.available_quantity;
        // console.log(row)
        newData.splice(index, 1, { ...item, ...row });
        // console.log(newData)
        // console.log(item)
        if (apiSave) {
          await apiSave(newData[index], newData);
        }else {
          setDataSource(newData);
        }
        
        setEditingKey('')
      }
    } catch (err) {
      console.log('Validate Failed:', err)
    }
  }

  const removeEntry = (record) => {
    let key = record.key;
    let entries = dataSource.filter((item) => item.key !== key)
    setDataSource(entries);
    
  }

  // {record.status !== 'save' && <Button type="text" onClick={()=>onClick(record)} icon={<FaClockRotateLeft />} className="mr-2">History</Button>}
  //     {record.status === 'save' && <Button type="text" onClick={()=>onClick(record)} icon={<VscGitStashApply />} className="mr-2">Apply</Button>}

  columns[columns.length - 1]['render'] = (_, record) =>
    ActionColumn(_, record, isEditing, save, edit, cancel, removeEntry, onClick, handlenavigate)

  // if (status === 'posted')
  //   delete columns[columns.length - 1]['render']



  // useEffect(() => { 
  //   EventEmitter.subscribe('entry_selected', data => {
  //     const { option, form, key, dataIndex } = data;
  //     const { label, value } = option;
  //     if (dataIndex === 'taxes') {
  //       form.setFieldValue('tax'+key, option.map(tax => tax.label));
  //     }else if (dataIndex === 'analytics'){
  //       form.setFieldValue('analytic'+key, option.map(analytic => analytic.label));
  //     }else {
  //       form.setFieldValue(value, option.label);
  //     }
  //   });

  

  //   return () => {
  //     EventEmitter.unsubscribe('selected');
  //   }
  // },[]);


  // useEffect(() => {
  //   if (dataSource && accounts.length > 0) {
  //     dataSource.forEach((transaction) => {
  //       let account = accounts.find((account) => account._id === transaction.account_id);
  //       {account && form.setFieldValue(`${account._id}`, `${account.code} ${account.name}`);}
  //       if (transaction.analytics !== undefined) {
  //         let analytics_ = analytics.filter((analytic) => transaction.analytics.includes(analytic._id))
  //         form.setFieldValue('analytic'+transaction.key, analytics_.map(analytic => analytic.name));
  //       }
  //       if (transaction.taxes !== undefined) {
  //         let taxes_ = taxes.filter((tax) => transaction.taxes.includes(tax._id))
  //         form.setFieldValue('tax'+transaction.key, taxes_.map(tax => tax.name));
  //       }
  //     });
  //   }
  // },[]);

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
    ...col,
    onCell: (record) => ({
      record,
      editable: col.editable,
      dataIndex: col.dataIndex,
      title: col.title,
      form: form,
      inputType: (col.dataIndex.includes('_id') || col.dataIndex === 'trigger') ? 'select' : (col.dataIndex.includes('quantity')) ? 'number' : col.dataIndex.includes('date') ? 'date' : 'text',
      options: 
        col.dataIndex === 'product_id' && products.map(product => ({value: product.id, label: `${product.name}`, vendors: product.vendorproducts})) ||
        col.dataIndex.includes('location') && locations.map(location => ({value: location.id, label: location.name})) ||
        col.dataIndex === 'user_id' && users.map(user => ({value: user.id, label: user.name})) ||
        col.dataIndex === 'preferred_route_id' && routes.map(route => ({value: route.id, label: route.name})) ||
        col.dataIndex === 'trigger' && triggers,
      editing: isEditing(record),
    }),
  }});

  return (
    <Form 
        form={form} 
        component={false} 
        initialValues={{}}
        labelAlign='right'
        labelCol={{span: 15}}
      >
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        rowSelection={rowSelection && rowSelection}
        dataSource={dataSource}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={false}
        rowKey={'key'}

      />
      {/* {status !== 'posted' && <Button onClick={addEntry}>Add Entry</Button>} */}
    </Form>
  );
};

export default RowEditableTable;
